<template>
	<modal :modal-name="'summaryEditor'" class="modal2">
		<template #modal-header>
			<h4 class="modal-title">Edit Provider - {{ summaryData.articleProviderName }}</h4>
		</template>
		<template #modal-body>
			<div class="card">
				<header class="card-header language-list">
					<lang-selector></lang-selector>
				</header>
				<div class="card-body">
					<div class="form-group">
						<label for="summary-tagline">Summary Tagline</label>
						<input @keypress="canEdit" id="summary-tagline" name="summary-tagline" type="text" v-model="summaryData.translations[clickedLang].summary_tagline" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
						<p class="input-error" v-if="errors.errors[errorModalSummaryTagLine]">{{ errors.errors[errorModalSummaryTagLine] }}</p>
					</div>
					<div class="form-group">
						<label for="steroid-tagline">Steroid Tagline</label>
						<input @keypress="canEdit" id="steroid-tagline" name="steroid-tagline" type="text" v-model="summaryData.translations[clickedLang].steroid_tagline" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
					</div>
					<div class="form-group">
						<label for="steroid-tagline">Verdict Tagline</label>
						<input @keypress="canEdit" id="verdict-tagline" name="steroid-tagline" type="text" v-model="summaryData.translations[clickedLang].verdict_tagline" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
					</div>
					<div class="form-group">
						<label for="provider-summary">Summary</label>
						<p class="input-error" v-if="errors.errors[errorModalSummaryCurrentLanguage]">{{ errors.errors[errorModalSummaryCurrentLanguage] }}</p>
						<editor
								id="provider-summary"
								:api-key="tinyMCEApiKey"
								:init="tinyMCEConfig"
								v-model="summaryData.translations[clickedLang].summary"
								:key="clickedLang"
								:disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale"
						/>
					</div>
					<div class="form-group">
						<label for="tested_by">Tested By</label>
						<div class="input-group">
							<select id="tested_by" v-model="summaryData.testedBy">
								<option :value="null">Please select an Author</option>
								<option :value="author.id" v-for="author in testedByAuthors">{{ author.name }}</option>
							</select>
						</div>
					</div>
					<div class="flex box">
						<div class="six">
							<div class="form-group">
								<label for="provider-likes">Likes</label>
								<div class="input-group">
									<input @keypress="canEdit" id="provider-likes" name="provider-likes" type="text" v-model="additionalLike" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
									<a @click="addPro()" class="btn btn-primary" href="#"><i class="fas fa-plus"></i> Add</a>
								</div>
							</div>
							<div class="table-responsive">
								<table>
									<thead>
										<tr>
											<th>Value</th>
											<th class="actions">Actions</th>
										</tr>
									</thead>
									<draggable :element="'tbody'" @end="drag=false" @start="drag=true" group="likes" v-model="summaryData.prosCons.pros[clickedLang]">
										<tr class="draggable" v-for="(item, index) in summaryData.prosCons.pros[clickedLang]">
											<td>{{ item.value }}</td>
											<td>
												<a @click="removePro(index)" class="btn btn-icon btn-danger" href="#" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
											</td>
										</tr>
									</draggable>
								</table>
							</div>
						</div>
						<div class="six">
							<div class="form-group">
								<label for="provider-dislikes">Dislikes</label>
								<div class="input-group">
									<input @keypress="canEdit" id="provider-dislikes" name="provider-dislikes" type="text" v-model="additionalDislike" :disabled="userRoles.includes('users.translator') && clickedLang === defaultLocale">
									<a @click="addCon()" class="btn btn-primary" href="#"><i class="fas fa-plus"></i> Add</a>
								</div>
							</div>
							<div class="table-responsive">
								<table>
									<thead>
										<tr>
											<th>Value</th>
											<th class="actions">Actions</th>
										</tr>
									</thead>
									<draggable :element="'tbody'" @end="drag=false" @start="drag=true" group="dislikes" v-model="summaryData.prosCons.cons[clickedLang]">
										<tr class="draggable" v-for="(item, index) in summaryData.prosCons.cons[clickedLang]">
											<td>{{ item.value }}</td>
											<td>
												<a @click="removeCon(index)" class="btn btn-icon btn-danger" href="#" title="Delete"><i class="fas fa-fw fa-trash"></i></a>
											</td>
										</tr>
									</draggable>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template #modal-footer>
			<a @click="saveProviderDetails" class="btn btn-md btn-success" href="#" v-if="userRoles.includes('articles.update')"><i class="fas fa-save"></i> Save Changes</a>
		</template>
	</modal>
</template>

<script>
import {eventBus} from "../../app";
import draggable from 'vuedraggable';
import Errors from "../../Utils/Errors";
import Modal from "../Modal/Modal";

export default {
	name: 'ArticleCommercialSummaryEditor',
	components: {Modal, draggable},
	props: {
		articleId: {
			required: true
		},
		authors: {
			required: true
		}
	},
	data() {
		return {
			summaryData: null,
			clickedLang: this.$defaultLanguage.locale,
			defaultLocale: this.$defaultLanguage.locale,
			userRoles: this.$currentUserRoles,
			tinyMCEApiKey: this.$tinyMCEApiKey,
			tinyMCEConfig: this.$tinyMCEConfig,
			additionalLike: '',
			additionalDislike: '',
			testedByAuthors: this.authors,
			errors: new Errors()
		}
	},
	created() {
		let vm = this;

		// When setActiveStatus method ran, change article data in form fields
		/* From LangSelectorCommercialModal */
		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});
		eventBus.$on('onSummaryEditorModalOpen', function (summaryData) {
			vm.summaryData = summaryData;
			eventBus.$emit('onModalOpen_summaryEditor');
			eventBus.$emit('onLoaderFinish');
		});
	},
	methods: {
		closeModal: function () {
			eventBus.$emit('onModalClose_summaryEditor');
			this.clickedLang = this.$defaultLanguage.locale;
			this.errors = new Errors();
			this.summaryData = null;
			this.additionalLike = '';
			this.additionalDislike = '';
		},
		addPro: function () {
			this.summaryData.prosCons.pros[this.clickedLang].push({'value': this.additionalLike});
			this.additionalLike = '';
			this.$toastr.success('Like added', 'Success');
		},
		addCon: function () {
			this.summaryData.prosCons.cons[this.clickedLang].push({'value': this.additionalDislike});
			this.additionalDislike = '';
			this.$toastr.success('Dislike added', 'Success');
		},
		removePro: function (index) {
			this.summaryData.prosCons.pros[this.clickedLang].splice(index, 1);
			this.$toastr.success('Like deleted', 'Success');
		},
		removeCon: function (index) {
			this.summaryData.prosCons.cons[this.clickedLang].splice(index, 1);
			this.$toastr.success('Dislike deleted', 'Success');
		},
		saveProviderDetails: function () {
			let vm = this;
			let originData = _.cloneDeep(vm.summaryData);
			for (let i = 0; i < this.$availableLanguages.length; i++) {
				if (originData.translations[this.$availableLanguages[i].locale] &&
						(originData.translations[this.$availableLanguages[i].locale].steroid_tagline === null || originData.translations[this.$availableLanguages[i].locale].steroid_tagline === '') &&
						(originData.translations[this.$availableLanguages[i].locale].verdict_tagline === null || originData.translations[this.$availableLanguages[i].locale].verdict_tagline === '') &&
						(originData.translations[this.$availableLanguages[i].locale].summary === null || originData.translations[this.$availableLanguages[i].locale].summary === '') &&
						(originData.translations[this.$availableLanguages[i].locale].summary_tagline === null || originData.translations[this.$availableLanguages[i].locale].summary_tagline === '')) {
					delete (originData.translations[this.$availableLanguages[i].locale]);
				}
			}
			originData.tested_by = vm.summaryData.testedBy;

			eventBus.$emit('onLoaderStart');
			axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.articleId + '/saveProviderDetails/', originData)
				.then(function (response) {
					eventBus.$emit('onLoaderFinish');
					eventBus.$emit('setImportedStatus', vm.summaryData.providerListPosition);
					vm.$toastr.success('Provider details saved successfully', 'Success');
					vm.closeModal();
				})
				.catch(function (e) {
					eventBus.$emit('onLoaderFinish');
					vm.errors.record(e.response.data);
					vm.$toastr.error('Provider details save failed.', 'Error');
				});
		},
		canEdit: function (event) {
			let vm = this;
			if (vm.userRoles.includes('users.translator') && vm.clickedLang === vm.defaultLocale) {
				event.preventDefault();
				event.stopPropagation();
			}
		}
	},
	computed: {
		errorModalSummaryCurrentLanguage: function () {
			return 'translations_' + this.clickedLang + '_summary';
		},
		errorModalSummaryTagLine: function () {
			return 'translations_' + this.clickedLang + '_summary_tagline';
		},
	}
}
</script>

<style scoped>

</style>
